export { default } from './CrossIconForUploader';
export { default as CrossIconForUploader } from './CrossIconForUploader';
